import { render, staticRenderFns } from "./Dlvzone.vue?vue&type=template&id=192642b1"
import script from "./Dlvzone.vue?vue&type=script&lang=js"
export * from "./Dlvzone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports